/**
 * Как было принято решение, приведшее к выбытию (коды `DeclutterOutcomeSource` бэкенда).
 *
 * <p>Архив знал, что вещь выброшена, а история вещи об этом молчала: «Выбыла из гардероба»
 * ничем не отличалось от «отдана подруге по совету стилиста». Источник отвечает на вопрос
 * «кто довёл решение до конца» — и в итогах архива, и в ленте вещи, поэтому подписи живут
 * в одном месте.</p>
 */
export const DISPOSAL_SOURCE_LABELS: Record<string, string> = {
    DECLUTTER_CONFIRM: 'решение принято в разборе',
    TRASH_CLEAR: 'завершено массово',
    THROW_AWAY: 'выброшено сразу',
    STATUS_CHANGE: 'отмечено в карточке вещи',
    SALE: 'подтверждено продажей',
    RESTORE: 'возврат в гардероб',
    AUTOPILOT: 'автопилот',
    STYLIST: 'совет AI-стилиста',
    UNKNOWN: 'источник неизвестен',
};

/** Подпись источника; неизвестный код показываем как есть, а не прячем за «прочее». */
export function disposalSourceLabel(code: string | null | undefined): string | null {
    if (!code) return null;
    return DISPOSAL_SOURCE_LABELS[code] ?? code;
}
